<template>
    <div>
        <action-bar>
            <router-link :to="{name: 'infobox-create'}">Neue Infobox erstellen</router-link>
        </action-bar>
        <main class="content">
            <h1>Infoboxen</h1>
            <table class="table table-striped" v-if="infoboxes !== false">
                <thead>
                <tr>
                    <th>Title</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(infobox, index) in infoboxes">
                    <td>{{infobox.name.text}}</td>
                    <td class="text-right">
                        <a href="#" v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, infobox),
                            message: 'Bist du sicher, dass du die Infobox <strong>'+infobox.name.text+'</strong> löschen möchtest?'}"><i
                                class="fa fa-trash fa-fw"></i></a>
                        <router-link :to="{name: 'infobox-edit', params: {infoboxId: infobox.id}}"><i class="fa fa-edit fa-fw"></i>
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  asyncComputed: {
    infoboxes() {
      return axios
        .get("/api/" + store.state.language + "/infobox/list")
        .then(({ data }) => {
          return data.result;
        });
    }
  },
  methods: {
    remove(dialog, infobox) {
      this.infoboxes.splice(this.infoboxes.indexOf(infobox), 1);
      axios.post("/api/" + store.state.language + "/infobox/" + infobox.id + "/delete");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/infobox/List.vue